import { gql, MutationTuple, useMutation } from '@apollo/client';

export const CREATE_STUDENT_LEARNING_PATHWAY = gql`
  mutation CreateStudentLearningPathway(
    $studentId: NonEmptyString!
    $pathwayId: NonEmptyString!
    $skillMatchPercentage: Float!
  ) {
    createStudentLearningPathway(
      studentId: $studentId
      pathwayId: $pathwayId
      skillMatchPercentage: $skillMatchPercentage
    )
  }
`;

interface ICreateStudentLearningPathwayParams {
  studentId: string;
  pathwayId: string;
  skillMatchPercentage: number;
}

interface ICreateStudentLearningPathwayResponse {
  createStudentLearningPathway: boolean;
}

export const useMutationCreateStudentLearningPathway = (): MutationTuple<
  ICreateStudentLearningPathwayResponse,
  ICreateStudentLearningPathwayParams
> =>
  useMutation<ICreateStudentLearningPathwayResponse, ICreateStudentLearningPathwayParams>(
    CREATE_STUDENT_LEARNING_PATHWAY,
  );
